import { CustomFilters, DocumentCustomFilters, FilterTable, OpinionCustomFilters } from './types';

export const isDocumentCustomFilter = (customFilter: CustomFilters): customFilter is DocumentCustomFilters => customFilter.filterTable === FilterTable.DOCUMENT;
export const isOpinionCustomFilter = (customFilter: CustomFilters): customFilter is OpinionCustomFilters => customFilter.filterTable === FilterTable.OPINION;
